import styled from '@emotion/styled';
import { uiTheme as t } from './theme';
import Title from './Title';
import Description from './Description';

interface PageHeaderProps {
  title: string;
  description?: string;
}

const Wrapper = styled.header({ marginBottom: 28 });

const Stack = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: 9,
});

const Divider = styled.hr({
  border: 'none',
  borderTop: `1px solid ${t.color.border}`,
  margin: '20px 0 0',
});

/**
 * Molécula: encabezado de la vista. Compone `Title` y `Description` y cierra
 * con una línea divisoria. Es el patrón de cabecera que reutilizan todas las
 * pantallas de Configuración.
 */
const PageHeader = ({ title, description }: PageHeaderProps) => (
  <Wrapper>
    <Stack>
      <Title as="h1" size="page">
        {title}
      </Title>
      {description ? <Description size="page">{description}</Description> : null}
    </Stack>
    <Divider />
  </Wrapper>
);

export default PageHeader;
